{
  "closeRegisterForm": {
    "title": "Vil du avbryte registreringen av skogeier?",
    "description": "All informasjon du har fylt ut vil gå tapt",
    "actionLabel": "Avbryt registrering",
    "cancelLabel": "Lukk"
  },
  "archiveProperty": {
    "title": "Er du sikker på at du vil arkivere eiendommen?",
    "description": "Denne handlingen kan ikke angres, arkiverte eiendommer må legges til på nytt. Det vil det ikke lenger være mulig å opprette hogstavtale på denne eiendommen.",
    "actionLabel": "Arkiver eiendom"
  },
  "archivePropertyBlocked": {
    "title": "Denne eiendommen kan ikke arkiveres",
    "description": "Det er aktive oppdrag på denne eiendommen og den kan derfor ikke arkiveres."
  },
  "deleteItem": {
    "title": "Slett element",
    "description": "Er du sikker på at du vil slette dette elementet? Denne handlingen kan ikke angres.",
    "actionLabel": "Slett"
  },
  "removeCoOwner": {
    "title": "Er du sikker på at du vil slette representanten?",
    "description": "Denne handlingen kan ikke angres. Du må legge til personen på nytt dersom du angrer.",
    "actionLabel": "Slett representant"
  },
  "contactPersonModal": {
    "title": "Er du sikker på at du vil slette denne kontaktpersonen?",
    "description": "Denne handlingen kan ikke angres. Du må legge til personen på nytt dersom du angrer.",
    "actionLabel": "Slett kontaktperson"
  },
  "deletePowerOfAttorney": {
    "title": "Slett fullmaktsdokument?",
    "description": "Er du sikker på at du vil slette fullmaktsdokumentet fra serveren? Denne handlingen kan ikke angres.",
    "actionLabel": "Slett"
  },
  "cancelContractorRegistration": {
    "title": "Vil du avbryte registreringen av entreprenør?",
    "description": "All informasjon du har fylt ut vil gå tapt",
    "actionLabel": "Avbryt registrering"
  },
  "cancelShareholderRegistration": {
    "title": "Vil du avbryte registreringen av andelseier?",
    "description": "All informasjon du har fylt ut vil gå tapt",
    "actionLabel": "Avbryt registrering"
  },
  "cancelTimberbuyerRegistration": {
    "title": "Vil du avbryte registreringen av tømmerkjøper?",
    "description": "All informasjon du har fylt ut vil gå tapt",
    "actionLabel": "Avbryt registrering"
  },
  "cancelPartnerAdd": {
    "title": "Vil du avbryte å legge til partner?",
    "description": "All informasjon du har fylt ut vil gå tapt",
    "actionLabel": "Avbryt tillegg",
    "cancelLabel": "Lukk"
  },
  "cancelPartnerRemove": {
    "title": "Vil du avbryte å fjerne partner?",
    "description": "All informasjon du har fylt ut vil gå tapt",
    "actionLabel": "Avbryt fjerning",
    "cancelLabel": "Lukk"
  },
  "cancelPartnerRemoveChoice": {
    "title": "Er du sikker på at du vil avbryte?",
    "description": "Endringer du har gjort vil ikke bli lagret.",
    "actionLabel": "Avbryt uten å lagre",
    "cancelLabel": "Fortsett redigering"
  },
  "confirmPartnerRemove": {
    "title": "Er du sikker på at du vil fjerne partneren?",
    "description": "Denne handlingen kan ikke angres.",
    "actionLabel": "Fjern partner",
    "cancelLabel": "Avbryt"
  }
}
